package com.appcreator.compose.components.basic

import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ProgressIndicatorDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.appcreator.blueprint.components.basic.ProgressIndicatorComponent


@Composable
fun ProgressIndicatorComposable(
    modifier: Modifier,
    component: ProgressIndicatorComponent
) {
    val mod = component.size?.let {
        modifier.size(it.dp)
    }?: modifier

    val strokeWidth = component.lineThickness?.dp ?: ProgressIndicatorDefaults.CircularStrokeWidth

    CircularProgressIndicator(mod, strokeWidth = strokeWidth)
}
